module.exports = __webpack_public_path__ + "img/ckmh-bg.bcc4ff4e.png";